import { render } from "./termCustom.vue?vue&type=template&id=4b195ea0&scoped=true"
import script from "./termCustom.vue?vue&type=script&lang=js"
export * from "./termCustom.vue?vue&type=script&lang=js"

import "./termCustom.vue?vue&type=style&index=0&id=4b195ea0&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/edu2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b195ea0"]])

export default __exports__